module.exports = __webpack_public_path__ + "static/mayday-1fb3d4a074a3abba06b05ca9d9541af0.jpg";